import React from 'react';
import { t } from 'i18next';
import { ButtonDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import { bindActionCreators } from 'redux';
import * as actions from '../store/actions';
import { connect } from 'react-redux';
import routes from '../routing/routes';
import { reverse } from 'named-urls';

class GroupSidebar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ddOpen: false
        };
    }

    changeGroup = (item) => {
        this.props.actions.groupUpdate(item);

        let selectedLocation = null
        if (item.locations && item.locations.length === 1) {
            selectedLocation = item.locations[0];
        }
        this.props.actions.locationUpdate(selectedLocation);

        //reload
        let location = this.props.location.pathname;

        if (location.startsWith(reverse(routes.agenda.myagenda, { agenda: this.props.agenda.id }))) {
            this.props.history.push(location);
        } else {
            this.props.history.push(this.props.location.pathname);
        }
    }

    toggle = () => this.setState({
        ddOpen: !this.state.ddOpen
    })

    render() {
        const { groups } = this.props.client;
        const btnColor = this.props.group ? 'default' : 'danger';

        if (groups.length === 1) {
            return (
                <span>{this.props.group.name}</span>
            )
        } else {
            return (
                <ButtonDropdown color={btnColor} isOpen={this.state.ddOpen} toggle={this.toggle} className="btn-block mt-2">
                    <DropdownToggle color={btnColor} size="sm" caret>
                        {this.props.group ? this.props.group.name : t('common:choose.group')}
                    </DropdownToggle>
                    <DropdownMenu>
                        {
                            groups.map((item, i) => {
                                return (
                                    <DropdownItem key={i} onClick={() => this.changeGroup(item)} active={item.id !== this.props.group.id ? false : true}>
                                        {item.name}
                                    </DropdownItem>
                                )
                            })
                        }
                    </DropdownMenu>
                </ButtonDropdown>
            );
        }
    }
}

const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(null, mapDispatchToProps)(GroupSidebar);